import { PlacementSearchFilterName } from 'app/components/GlobalSearch/Placement/SearchUtils';
import { FilterCompTypes } from 'app/ComponentLibrary/Filter/utils';
import { calculateTreeCount } from '@AMIEWEB/Common/TreeView/TreeViewHelpers';

export const PlacementPayPackagesFilterName = {
  placementStatus: PlacementSearchFilterName.status,
  archiveStatus: PlacementSearchFilterName.archiveStatus,
  payPackageStatus: 'payPackageStatus',
  candidateId: 'candidateId',
  candidateName: 'candidateName',
  orderId: 'orderId',
} as const;

export const archiveOpts = [
  { id: 0, labelPrefix: 'Archive', name: 'No', value: 'N' },
  { id: 1, labelPrefix: 'Archive', name: 'Yes', value: 'Y' },
];

export const defaultFilterValues = {
  [PlacementPayPackagesFilterName.archiveStatus]: archiveOpts[0],
  [PlacementPayPackagesFilterName.placementStatus]: [],
  [PlacementPayPackagesFilterName.payPackageStatus]: [],
  [PlacementPayPackagesFilterName.candidateId]: [],
  [PlacementPayPackagesFilterName.candidateName]: [],
  [PlacementPayPackagesFilterName.orderId]: [],
};

export const defaultPayPackageStatusOptions = [
  { id: 1, name: 'Pending', value: 'Pending' },
  { id: 2, name: 'Approval Requested', value: 'Approval Requested' },
  { id: 3, name: 'Approved', value: 'Approved' },
  { id: 4, name: 'Verified', value: 'Verified' },
];
type WithField = { name: string };

export const reorderByField = <T extends WithField>(items: T[], order: string[]): T[] => {
  const map = new Map(items.map(item => [item.name, item]));

  // 1. Pick items in desired order
  const ordered = order.map(field => map.get(field)).filter(Boolean) as T[];

  // 2. Append remaining items (not specified in order)
  const remaining = items.filter(item => !order.includes(item.name));

  return [...ordered, ...remaining];
};

export class PlacementPayPackagesFilterSpecs {
  constructor(
    public filterSpecs: {
      statusOpts: any[];
      payPackageStatusOpts: any[];
      candidateIdOpts?: any[];
      candidateNameOpts?: any[];
      orderIdOpts?: any[];
    },
    public t: any,
    public options?: { includeCandidateFilters?: boolean; includeOrderIdFilter?: boolean },
  ) {}

  getSpecs = () => {
    const includeCandidates = this.options?.includeCandidateFilters !== false;
    const includeOrderId = this.options?.includeOrderIdFilter === true;
    return [
      {
        filterName: this.t('search.globalSearch.placement.filterNames.archive'),
        name: PlacementPayPackagesFilterName.archiveStatus,
        type: FilterCompTypes.TYPEAHEADDROPDOWN,
        options: archiveOpts,
        hideClearAll: true,
      },
      ...(includeOrderId
        ? [
            {
              filterName: 'Order ID',
              name: PlacementPayPackagesFilterName.orderId,
              type: FilterCompTypes.TYPEAHEADDROPDOWN,
              options: this.filterSpecs.orderIdOpts || [],
              isMultiSelect: true,
              isSelectAll: true,
              applyOnClickAway: true,
              applyOnEnter: true,
              searchOnCharacterCount: 1,
            },
          ]
        : []),
      ...(includeCandidates
        ? [
            {
              filterName: 'Candidate ID',
              name: PlacementPayPackagesFilterName.candidateId,
              type: FilterCompTypes.TYPEAHEADDROPDOWN,
              options: this.filterSpecs.candidateIdOpts || [],
              isMultiSelect: true,
              isSelectAll: true,
              applyOnClickAway: true,
              applyOnEnter: true,
              searchOnCharacterCount: 1,
            },
            {
              filterName: 'Candidate',
              name: PlacementPayPackagesFilterName.candidateName,
              type: FilterCompTypes.TYPEAHEADDROPDOWN,
              options: this.filterSpecs.candidateNameOpts || [],
              isMultiSelect: true,
              isSelectAll: true,
              applyOnClickAway: true,
              applyOnEnter: true,
              searchOnCharacterCount: 1,
            },
          ]
        : []),
      {
        filterName: 'Placement Status',
        name: PlacementPayPackagesFilterName.placementStatus,
        type: FilterCompTypes.TREE,
        isMultiSelect: true,
        options: this.filterSpecs.statusOpts,
        placeholder: 'Select',
        version2: true,
        returnsObjectAsValue: true,
        size: 'large',
        customSelectedCount: value => calculateTreeCount(value),
        applyOnClickAway: true,
        applyOnEnter: true,
        isSelectAll: true,
      },
      {
        filterName: 'Pay Package Status',
        name: PlacementPayPackagesFilterName.payPackageStatus,
        type: FilterCompTypes.TYPEAHEADDROPDOWN,
        options: this.filterSpecs.payPackageStatusOpts,
        isMultiSelect: true,
        isSelectAll: true,
        applyOnClickAway: true,
        applyOnEnter: true,
        searchOnCharacterCount: 1,
      },
    ];
  };
}
